import React from "react";
import { useFCategoryContainer } from "./hooks/FCategoryContainer";
import styles from "./style/FCategoryContainer.module.scss";
import { MailIcon, PhoneIcon } from "@heroicons/react/solid";

const FCategoryContainer = ({ arrayCategory = [] }) => {
  return (
    <div className="grid grid-cols-2 xxs:grid-cols-3 ">
      {arrayCategory.map((category, index) => {
        return (
          <div key={index} className="py-4 border-0">
            <div className="border-0 grid grid-rows-2 ">
              <div className="border-0 row-span-1 grid place-items-center">
                <div
                  className="w-[80px] h-[80px] bg-[#e9e9e9] grid place-items-center rounded-full cursor-pointer"
                  onClick={category.onclick}
                >
                  <img src={category.imageUrl} className="w-[50px] h-[50px]" />
                </div>
              </div>
              <div className="border-0 row-span-1 text-center text-[5vw] xxs:text-[15px] grid place-items-center">
                {category.name}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FCategoryContainer;
